export default {
  items: [],
  pagination: {},
  size: 100,
  isBusy: false,
  filter: {},
  form: {},
};
